export const Spacer = 24;
export const FallbackWidth = 244;
export const PreviewShowDelay = 250;
export const PreviewHideDelay = 125;
